import { loadStripe } from '@stripe/stripe-js'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { myLanguageState } from '~/features/i18n/store'
import browserEnv from './env/browserEnv'

export const useStripePromise = () => {
  const myLanguage = useRecoilValue(myLanguageState)
  const locale = myLanguage ?? 'en'

  const stripePromise = useMemo(
    () => loadStripe(browserEnv.NEXT_PUBLIC_STRIPE_PK, { locale }),
    [locale],
  )

  return stripePromise
}
